import { $ } from "../../../common/scripts/Libs";
window.$ = window.jQuery = $;
import 'slick-carousel';

class SlickSlider {

    constructor(node) {
        this.node = node;
    }

    init() {
        //console.log()
    }

}

JSModules['SlickSlider'] = SlickSlider;
export default SlickSlider;
